import React from 'react';

const LoadingSmall = () => (
	<div className="col-sm-12">
	<div className="loading-small-squeeze text-center">
		<span></span><span></span><span></span><span></span><span></span>
	</div>
	</div>
);

export default LoadingSmall;



// WEBPACK FOOTER //
// ./components/LoadingSmall.js